import { Mail, Phone, Facebook, MapPin } from "lucide-react";
import { SITE } from "../config/site";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-ink/10 bg-white pb-10 pt-16 text-ink">
      <div className="mx-auto max-w-7xl px-6 lg:px-12">
        <div className="grid gap-12 md:grid-cols-[1.5fr_1fr_1fr]">
          <div>
            <img
              src="/logo.png"
              alt={`${SITE.name} logo`}
              data-testid="footer-logo"
              className="h-14 w-auto"
            />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-slateblue">
              Insured, bonded and locally owned — reliable, detail-oriented cleaning for
              homes and businesses across the Avalon.
            </p>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-seafoam">Contact</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li>
                <a href={`mailto:${SITE.email}`} data-testid="footer-email-link" className="flex items-center gap-3 text-slateblue transition-colors hover:text-ocean">
                  <Mail className="h-4 w-4 text-seafoam" /> {SITE.email}
                </a>
              </li>
              <li>
                <a href={SITE.phoneHref} data-testid="footer-phone-link" className="flex items-center gap-3 text-slateblue transition-colors hover:text-ocean">
                  <Phone className="h-4 w-4 text-seafoam" /> {SITE.phone}
                </a>
              </li>
              {SITE.facebook && (
                <li>
                  <a href={SITE.facebook} target="_blank" rel="noopener noreferrer" data-testid="footer-facebook-link" className="flex items-center gap-3 text-slateblue transition-colors hover:text-ocean">
                    <Facebook className="h-4 w-4 text-seafoam" /> Find us on Facebook
                  </a>
                </li>
              )}
            </ul>
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.3em] text-seafoam">Service Area</p>
            <p className="mt-5 flex items-start gap-3 text-sm leading-relaxed text-slateblue">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-seafoam" />
              St. John's · Mount Pearl · Paradise · CBS · and the whole Avalon
            </p>
            <p className="mt-3 text-sm text-slateblue/80">{SITE.scheduling}</p>
            <a
              href="#quote"
              data-testid="footer-quote-button"
              className="mt-6 inline-block rounded-full bg-ocean px-6 py-3 text-xs font-bold uppercase tracking-[0.25em] text-white transition-[background-color,transform] duration-300 hover:bg-seafoam hover:scale-[1.03]"
            >
              Get a Free Quote
            </a>
          </div>
        </div>
        <div className="mt-14 flex flex-col gap-3 border-t border-ink/10 pt-8 text-xs text-slateblue/70 sm:flex-row sm:items-center sm:justify-between">
          <p>© {new Date().getFullYear()} {SITE.legalName} · {SITE.name}. All rights reserved.</p>
          <p>{SITE.replyPromise} · We only use your contact details to respond to your enquiry.</p>
          <a href="/admin" data-testid="footer-admin-link" className="underline underline-offset-4 transition-colors hover:text-ocean">
            Owner Login
          </a>
        </div>
      </div>
    </footer>
  );
}
